<template>
    <form ref="form">
        <div class="question-text" v-html="getQuestionText"></div>

        <div v-for="(choice, index) in data.choices" :key="index" :class="{ 'spaced': choice.spaced }">
            <div class="input-group" :class="{ active: answer.choice === choice.id }">
                <label :for="`input_radio_`+choice.id">
                    <input
                        type="radio"
                        :name="data.id"
                        :id="`input_radio_`+choice.id"
                        :ref="`input_radio_${choice.id}`"
                        @change="selected(choice)"
                    >
                    <span v-html="getChoiceText(choice.id)"></span>

                    <span v-if="choice.custom">
                        <input
                            type="text"
                            :ref="`custom_${choice.id}`"
                            @keyup="setCustomValue(choice)"
                            @click="selected(choice)"
                        >
                    </span>
                </label>
            </div>
        </div>

        <button type="button" class="previous" @click="prev">Previous</button>
        <button
          @click.prevent="next"
          :disabled="nextBtnDisabled"
          :class="{ active: !nextBtnDisabled }"
          class="next"
        >
          Next
        </button>

        <!--<p>{{ answer }}</p>-->
    </form>
</template>

<script>
export default {
    name: 'single-choice',

    props: {
        data: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            answer: {
                question: this.data.id,
                choice: null,
                custom: null
            },
        }
    },

    mounted(){
      if ( this.data.randomize ){
        const head = this.data.choices.filter(item => {
            return item.text[this.$parent.lang].html.substr(0,1) !== '['
        })
        head.sort(() => Math.random() - 0.5)
        const tail = this.data.choices.filter(item => {
            return item.text[this.$parent.lang].html.substr(0, 1) === '['
        })
        this.data.choices = [...head, ...tail]
      }
    },

    computed: {
        nextBtnDisabled() {
            if ( this.data.mandatory && this.answer.choice === null && this.answer.custom === null ) {
                return true;
            }
            // verify if the choice selected as mandatory custom input
            let index = this.data.choices.findIndex(c => c.id === this.answer.choice)
            if (index !== -1){
                if (
                    this.data.choices[index].custom &&
                    // this.data.choices[index].custom.mandatory &&
                    this.answer.custom === null
                ) {
                    return true
                }
                if (
                    this.data.choices[index].custom &&
                    //this.data.choices[index].custom.mandatory &&
                    this.answer.custom === ''
                ) {
                    return true;
                }
            }
            return false;
        },

        getQuestionText() {
            const index = this.data.text.findIndex(t => t.lang == this.$parent.lang);
            return this.data.text[index].html;
        },
    },

    methods: {
        selected(choice){
            this.answer.choice = choice.id
            this.$refs[`input_radio_${choice.id}`][0].checked = true

            // tmp disabled, but the idea would be to define if the custom input must be filled or not
            // if ( choice.custom && choice.custom.mandatory ){
            if ( choice.custom ){
                if ( this.$refs[`custom_${choice.id}`][0]['value'] === '' ) {
                    return this.$refs[`custom_${choice.id}`][0].focus()
                }
            }
        },

        setCustomValue(choice) {
            this.answer.custom = this.$refs[`custom_${choice.id}`][0]['value'].trim()
            this.selected(choice)
        },

        next(){
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        resetCustom(newChoice, oldChoice) {
            console.log('reset custom');
            console.log(newChoice);
            console.log(oldChoice);
            if ( oldChoice !== null && this.$refs[`custom_${oldChoice}`]) {
                this.$refs[`custom_${oldChoice}`][0].value = '';
            }
            this.answer.custom = null;
        },

        getChoiceText(choiceId) {
            const index = this.data.choices.findIndex(c => c.id === choiceId);
            const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
            return this.data.choices[index].spaced ? this.data.choices[index].text[textIndex].html.substr(1) : this.data.choices[index].text[textIndex].html;
        }
    },

    watch: {
        'answer.choice': {
            handler: 'resetCustom',
            deep: true
        }
    }
}
</script>
